import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ShortUrlService } from "../../providers/short-url.service";
import { isNullOrUndefined } from "util";
import { Router, ActivatedRoute } from "@angular/router";
import { ScrollService } from "../../providers/scroll.service";

@Component({
  selector: 'app-short-url-graph',
  templateUrl: './short-url-graph.component.html',
  styleUrls: ['./short-url-graph.component.scss']
})
export class ShortUrlGraphComponent implements OnInit, AfterViewInit {
  public doughnutChartLabels: string[] = [];
  public doughnutChartData: number[] = [];
  public doughnutChartType: string = 'doughnut';
  months = ["Jan", "Feb", "Mar", "Apr", "May",
    "Jun", "Jul", "Aug", "Sep", "Oct",
    "Nov", "Dec"];
  doughnutTmp = {};

  public lineChartData: Array<any> = [
    { data: [], label: 'Number of Clicks per day' },
  ];
  public lineChartLabels: Array<any> = [];
  public lineChartOptions: any = {
    responsive: true
  };
  public lineChartLegend: boolean = true;
  public lineChartType: string = 'bar';

  lineTmp = {};

  constructor(
    public shortUrl: ShortUrlService,
    private route: ActivatedRoute,
    private router: Router,
    private scroll: ScrollService
  ) { }

  ngOnInit() {
    if (isNullOrUndefined(this.shortUrl.shortLinkUrl)) {
      this.router.navigate(['']);
    }
    else {
      for (let click of this.shortUrl.shortLinkStats.clickData) {
        if (isNullOrUndefined(this.doughnutTmp[click.city + ', ' + click.state])) {
          this.doughnutTmp[click.city + ', ' + click.state] = 1;
        }
        else {
          this.doughnutTmp[click.city + ', ' + click.state] += 1;
        }
        let tmp = new Date(click.clicked_on);

        if (isNullOrUndefined(this.lineTmp[this.months[tmp.getMonth()] + ' ' + tmp.getDate()])) {
          this.lineTmp[this.months[tmp.getMonth()] + ' ' + tmp.getDate()] = 1;
        }
        else {
          this.lineTmp[this.months[tmp.getMonth()] + ' ' + tmp.getDate()] += 1;
        }
      }

      for (let item in this.lineTmp) {
        this.lineChartLabels.push(item);
        this.lineChartData[0].data.push(this.lineTmp[item]);
      }
      for (let item in this.doughnutTmp) {
        this.doughnutChartLabels.push(item);
        this.doughnutChartData.push(this.doughnutTmp[item])
      }
    }

  }

  ngAfterViewInit() {
    this.scroll.scrollToTop();
  }

  public chartClicked(e: any): void {
    console.log(e);
  }

  public chartHovered(e: any): void {
    console.log(e);
  }

  goBack() {
    this.router.navigate(['../../'], { relativeTo: this.route });
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/short-url-graph/short-url-graph.component.ts